import React from 'react';
import { Button } from 'antd';
import { CurrencyDollarIcon } from '@phosphor-icons/react';
import { useCurrentUser } from '../../../../contexts/UserContext';
import { EditorIconTooltip } from '../EditorIconTooltip';
import {
    formatEditorPpw,
    useEditorPricingStore,
} from '../Three-JS-Viewer/editorPricing';

/** Canvas toolbar cell that surfaces the recommended PPW and toggles the pricing card. */
const EditorPricingToolbarButton: React.FC = () => {
    const { hasCapability } = useCurrentUser();
    const active = useEditorPricingStore((state) => state.active);
    const status = useEditorPricingStore((state) => state.status);
    const recommendation = useEditorPricingStore((state) => state.recommendation);
    const cardOpen = useEditorPricingStore((state) => state.cardOpen);
    const toggleCard = useEditorPricingStore((state) => state.toggleCard);

    if (!hasCapability('Show_OneButton') || !active) return null;

    const ppw = recommendation?.ppw ?? null;
    const label = status === 'loading' && ppw == null ? '…' : formatEditorPpw(ppw);
    const tooltip = recommendation
        ? `Pricing — ${recommendation.partner} ${formatEditorPpw(ppw)}`
        : 'Pricing';

    return (
        <Button
            className="editor-toolbar-pricing"
            type={cardOpen ? 'primary' : 'default'}
            size="large"
            id="pricingTool"
            onClick={toggleCard}
            icon={
                <EditorIconTooltip title={tooltip} zone="toolbar">
                    <span className="editor-icon-tooltip__hit">
                        <CurrencyDollarIcon size={22} weight="regular" />
                    </span>
                </EditorIconTooltip>
            }
        >
            <span className="editor-toolbar-pricing__value">{label}</span>
        </Button>
    );
};

export default EditorPricingToolbarButton;
